import React from "react";
import { CheckCircle2, Mail } from "lucide-react";
import { useLang } from "@/i18n";
import Seo from "@/components/Seo";
import { NewsletterBox } from "@/components/NewsletterBox";

export default function Newsletter() {
  const { lang, t } = useLang();
  const days = lang === "it"
    ? [
        "Giorno 1 — La guardia: la base di tutto",
        "Giorno 2 — I 5 errori meccanici nel gancio",
        "Giorno 3 — Footwork: muoversi senza sbilanciarsi",
        "Giorno 4 — Respirazione e ritmo sotto pressione",
        "Giorno 5 — Costruire una routine sostenibile",
      ]
    : [
        "Day 1 — The guard: the base of everything",
        "Day 2 — The 5 mechanical mistakes in the hook",
        "Day 3 — Footwork: moving without losing balance",
        "Day 4 — Breathing and rhythm under pressure",
        "Day 5 — Building a sustainable routine",
      ];

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-14">
      <Seo title={"Newsletter"} description={lang === "it" ? "Ogni settimana tecnica, curiosità e allenamenti di boxe e kickboxing nella tua email." : "Weekly boxing & kickboxing technique, curiosities and workouts in your inbox."} />
      <div className="flex items-center gap-2 text-[#E63946]">
        <Mail size={18} />
        <span className="text-xs font-mono uppercase tracking-[0.25em]">{t("news_title")}</span>
      </div>
      <h1 className="mt-3 font-heading text-4xl sm:text-5xl font-black uppercase text-white">{t("news_title")}</h1>
      <p className="mt-4 text-zinc-300 max-w-2xl">{t("news_sub")}</p>

      <div className="mt-10 grid md:grid-cols-2 gap-8 items-start">
        <div className="space-y-3">
          {days.map((d, i) => (
            <div key={i} className="flex items-center gap-3 bg-[#14161b] border border-[#272b35] rounded-lg p-4">
              <CheckCircle2 size={20} className="text-[#10B981] shrink-0" />
              <span className="text-sm text-zinc-200 font-semibold">{d}</span>
            </div>
          ))}
        </div>
        <NewsletterBox variant="newsletter-page" />
      </div>
    </div>
  );
}
